import React, { useState } from 'react'
import { Alert, Button, Card, CloseButton, Container, Form, InputGroup, Stack } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { serIsEmail,serIsMark, serIsTele, serSetRegister } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';

export default function Register() {

  const [currentCardId, setCurrentCardId] = useState(0);
  const [inputValues, setInputValues] = useState(Array(7).fill(''));
  const [msgError, setMsgError] = useState('');
  const [showPassword1, setShowPassword1] = useState('password');
  const [showPassword2, setShowPassword2] = useState('password');
  const [agreement, setAgreement] = useState(false);
  const {lg}=useSelector((state)=>state.language)

  const password1Click=()=>{
    if(showPassword1==='password'){
      setShowPassword1('text');
    }else{
      setShowPassword1('password');
    }
  };

  const password2Click=()=>{
    if(showPassword2==='password'){
      setShowPassword2('text');
    }else{
      setShowPassword2('password');
    }
  };

  const card1=(
    <div>
      <div className='py-4'>
        <h3>{langList.register1[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-4">
        <InputGroup.Text>
          <img src='./pic/envelope.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card1-0'
          type="text"
          placeholder={langList.register2[lg]}
          value={inputValues[0]}
          onChange={e=>{handleInputChange(0,e.target.value)}}
        />
      </InputGroup>
      <InputGroup className="mb-1">
        <InputGroup.Text className='px-3'>
          <img src='./pic/person.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card1-1'
          placeholder={langList.register3[lg]}
          value={inputValues[0]}
          disabled />
      </InputGroup>
      <div className='pb-5 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.register4[lg]}</li>
        <li>{langList.register5[lg]}</li>
        <li>{langList.register6[lg]}</li>
      </ul>
    </div>
  );
  
  const card2=(
    <div>
      <div className='py-4'>
        <h3>{langList.register7[lg]}</h3>
      </div>
      <InputGroup className="mb-4">
        <InputGroup.Text className='px-3'>
          <img src='./pic/envelope.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card2-0'
          type="text"
          placeholder={langList.register8[lg]}
          value={inputValues[0]}
          disabled
        />
      </InputGroup>
      <InputGroup size="lg" className="mb-1">
        <InputGroup.Text className='px-3'>
          <img src='./pic/envelope-check.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card2-1'
          placeholder={langList.register9[lg]}
          value={inputValues[1]}
          onChange={e=>{handleInputChange(1,e.target.value)}}
        />
      </InputGroup>
      <div className='pb-5 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.register10[lg]}</li>
        <li>{langList.register11[lg]}</li>
      </ul>
    </div>
  );

  const card3=(
    <div>
      <div className='py-4'>
        <h3>{langList.register12[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-4">
        <InputGroup.Text className='px-3'>
          <img src='./pic/lock.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card3-0'
          type={showPassword1}
          placeholder={langList.register13[lg]}
          value={inputValues[2]}
          onChange={e=>{handleInputChange(2,e.target.value)}}
        />
        <InputGroup.Text style={{cursor: 'pointer'}} onClick={password1Click}>
          <img src={showPassword1==='password'?'./pic/eye.svg':'./pic/eye-slash.svg'} alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <InputGroup size="lg" className="mb-1">
        <InputGroup.Text className='px-3'>
          <img src='./pic/lock.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card3-1'
          type={showPassword2}
          placeholder={langList.register14[lg]}
          value={inputValues[3]}
          onChange={e=>{handlePasswordChange(3,e.target.value)}}
        />
        <InputGroup.Text style={{cursor: 'pointer'}} onClick={password2Click}>
          <img src={showPassword2==='password'?'./pic/eye.svg':'./pic/eye-slash.svg'} alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <div className='pb-5 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.register15[lg]}</li>
        <li>{langList.register16[lg]}</li>
        <li>{langList.register17[lg]}</li>
      </ul>
    </div>
  );

  const card4=(
    <div>
      <div className='py-4'>
        <h3>{langList.register18[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-1">
        <InputGroup.Text className='px-3'>
          <img src='./pic/telephone.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card4-0'
          type={showPassword1}
          placeholder={langList.register19[lg]}
          value={inputValues[4]}
          onChange={e=>{handleInputChange(4,e.target.value)}}
        />
      </InputGroup>
      <div className='pb-5 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3 pt-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.register20[lg]}</li>
        <li>{langList.register21[lg]}</li>
        <li>{langList.register22[lg]}</li>
        <li>{langList.register23[lg]}</li>
      </ul>
    </div>
  );

  const card5=(
    <div>
      <div className='py-4'>
        <h3>{langList.register24[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-3">
        <InputGroup.Text className='px-3'>
          <img src='./pic/chat-text.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card5-0'
          as="textarea"
          type={showPassword1}
          placeholder={langList.register25[lg]}
          value={inputValues[5]}
          onChange={e=>{handleInputChange(5,e.target.value)}}
        />
      </InputGroup>
      <InputGroup size="lg" className="mb-1">
        <InputGroup.Text className='px-3'>
          <img src='./pic/check-circle.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card5-1'
          type='text'
          placeholder={langList.register26[lg]}
          value={inputValues[6]}
          onChange={e=>{handleInputChange(6,e.target.value)}}
        />
      </InputGroup>
      <div className='pb-4 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3 pt-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.register27[lg]}</li>
        <li>{langList.register28[lg]}</li>
        <li>{langList.register29[lg]}</li>
        <li>{langList.register30[lg]}</li>
      </ul>
    </div>
  );

  const card6=(
    <div className='d-flex justify-content-center align-items-center p-5'>
      <img src='./pic/award.svg' alt='' width={'36px'}/>
      <h3 className='my-1 ms-3'>{langList.register31[lg]}</h3>
    </div>
  );

  const cardContents = [card1,card2,card3,card4,card5,card6];

  const handleInputChange = (index,value) => { 
    const newInputValues=[...inputValues];
    newInputValues[index]=value;
    setInputValues(newInputValues);
  }

  const handlePasswordChange = (index,value) => {
    handleInputChange(index,value);
    if (!(value===inputValues[2].substring(0,value.length))) {
      setMsgError(`${langList.register32[lg]}`);
    }else{
      setMsgError('');
    }
  };

  const handleNextClick = () => {
    if(msgError){
      return;
    };
    switch (currentCardId) {
      case 0:{
        if(!agreement){
          setMsgError(`${langList.register33[lg]}`);
          return;
        };
        const regex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
        if(!regex.test(inputValues[0])){
          setMsgError(`${langList.register34[lg]}`);
          return;
        };
        serIsEmail({eml:inputValues[0]})
        .then(res =>{
          const code=res.code;
          if(code===3){
            setMsgError(`${langList.register35[lg]}`);
            return;
          };
          if(code!==4){
            setMsgError(`${langList.register36[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }
      case 1:{
        const regex=/^\d{4}$/;
        if(!regex.test(inputValues[1])){
          setMsgError(`${langList.register37[lg]}`);
          return;
        };
        serIsMark({eml:inputValues[0],mak:inputValues[1]})
        .then(res =>{
          const code=res.code;
          if(code===6){
            setMsgError(`${langList.register37[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }
      case 2:{
        if(!(inputValues[2]===inputValues[3])){
          setMsgError(`${langList.repwd1[lg]}`);
          return;
        };
        const regex1=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*\s).{8,20}$/;
        const regex2=/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,20}$/;
        const regex3=/^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,20}$/;
        const regex4=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,20}$/;
        if(!regex1.test(inputValues[2]) && !regex2.test(inputValues[2]) && 
           !regex3.test(inputValues[2]) && !regex4.test(inputValues[2])){
          setMsgError(`${langList.register39[lg]}`);
          return;
        };
        if (currentCardId < cardContents.length - 1) {
          setCurrentCardId(currentCardId + 1);
        };
        break;
      }
      case 3:{
        const regex=/^(\+?\d{1,3}\s?)?(\()?\d{1,4}(\))?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
        if(!regex.test(inputValues[4])){
          setMsgError(`${langList.getpwd1[lg]}`);
          return;
        };
        if(inputValues[4].length>18){
          setMsgError(`${langList.register40[lg]}`);
          return;
        }
        serIsTele({tel:inputValues[4]})
        .then(res =>{
          const code=res.code;
          if(code===7){
            setMsgError(`${langList.register41[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }
      case 4:{
        if(inputValues[5].trim()===''){
          setMsgError(`${langList.register42[lg]}`);
          return;
        };
        if(inputValues[6].trim()===''){
          setMsgError(`${langList.register43[lg]}`);
          return;
        };
        const regex = /^\s|\s$|^\s.*\s$/;
        if(regex.test(inputValues[6])){
          setMsgError(`${langList.register44[lg]}`);
          return;
        };
        if(inputValues[5].length>40){
          setMsgError(`${langList.register45[lg]}`);
          return;
        };
        if(inputValues[6].length>18){
          setMsgError(`${langList.register46[lg]}`);
          return;
        };
        serSetRegister({inp:inputValues})
        .then(res =>{
          const code=res.code;
          if(code===7){
            setMsgError(`${langList.register47[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }
      
    default:
      break;
  }
  };

  const handlePrevClick = () => {
    if (currentCardId > 0) {
      setCurrentCardId(currentCardId - 1);
    }
  };

  const navigate=useNavigate();
  const closeBtnClick = () => {
    navigate('/',{replace:true});
  };
  const handleToLogin = ()=>{
    navigate('/login',{replace:true});
  }
  const handleToAgree = (str)=>{
    navigate('/agreement',{replace:true,state:{str}});
  }

  const handleCheckChange = (e) => {
    setAgreement(e.target.checked);
  };

  if(msgError){
    setTimeout(() => {
      setMsgError('');
    }, 5000);
  };

  return (
    <Container className='d-flex justify-content-center align-items-center' style={{height:'100vh'}}>
      <Card className='shadow' style={{maxWidth:'25rem',width:'100%'}}>
        <Card.Header className='d-flex justify-content-between align-items-center py-3'>
          <span>{langList.login6[lg]}</span>
          <CloseButton onClick={closeBtnClick}/>
        </Card.Header>
        <Card.Body>
          {cardContents[currentCardId]}
        </Card.Body>
        <Card.Footer className='py-3'>
          {currentCardId ===0 &&
          <div className='d-flex justify-content-between align-items-center'>
            <Stack direction="horizontal" gap={0}>
              <Form.Check
                id='agreement'
                type='checkbox'
                checked={agreement}
                onChange={handleCheckChange}
              />
              <Button variant="link" className='px-0'
                onClick={()=>handleToAgree(lg+'0')}
              >{langList.register49[lg]}</Button>
            </Stack>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleNextClick}
            >{langList.getpwd13[lg]}</Button>
          </div>
          }
          {currentCardId !==0 &&
          currentCardId !== cardContents.length-2 &&
          currentCardId !== cardContents.length-1 &&
          <div className='d-flex justify-content-between align-items-center'>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handlePrevClick}
            >{langList.getpwd14[lg]}</Button>
            <div></div>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleNextClick}
            >{langList.getpwd13[lg]}</Button>
          </div>
          }
          {currentCardId === cardContents.length-2 &&
          <div className='d-flex justify-content-between align-items-center'>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handlePrevClick}
            >{langList.getpwd14[lg]}</Button>
            <div></div>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleNextClick}
            >{langList.getpwd15[lg]}</Button>
          </div>
          }
          {currentCardId === cardContents.length-1 &&
          <div className='d-flex justify-content-center align-items-center'>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleToLogin}
            >{langList.getpwd16[lg]}</Button>
          </div>
          }
        </Card.Footer>
      </Card>
    </Container>
  )
}
